// components/copilot/hooks/useAttachmentCache.js
import { useCallback, useEffect, useRef, useState } from "react";

export function useAttachmentCache(downloadAttachmentBlob) {
  const [attachmentUrlCache, setAttachmentUrlCache] = useState(() => ({}));
  const attachmentUrlCacheRef = useRef({});

  useEffect(() => {
    attachmentUrlCacheRef.current = attachmentUrlCache;
  }, [attachmentUrlCache]);

  const getAttachmentObjectUrl = useCallback(
    async (attachmentId) => {
      const cached = attachmentUrlCacheRef.current?.[attachmentId];
      if (cached) return cached;

      const blob = await downloadAttachmentBlob(attachmentId);
      const url = URL.createObjectURL(blob);

      setAttachmentUrlCache((prev) => ({ ...prev, [attachmentId]: url }));
      return url;
    },
    [downloadAttachmentBlob]
  );

  const cleanupAllAttachmentUrls = useCallback(() => {
    try {
      Object.values(attachmentUrlCacheRef.current || {}).forEach((u) => URL.revokeObjectURL(u));
    } catch {}
    setAttachmentUrlCache({});
    attachmentUrlCacheRef.current = {};
  }, []);

  // cleanup on unmount
  useEffect(() => {
    return () => cleanupAllAttachmentUrls();
  }, [cleanupAllAttachmentUrls]);

  return { getAttachmentObjectUrl, cleanupAllAttachmentUrls };
}
